module.exports = __webpack_public_path__ + "static/media/HEG.c79ab7a9.jpg";